export { useModal } from './useModal';
export type { useModalProps } from './useModal';
